<template>
  <div>
    <div class="row" style="display: flex; justify-content: center; margin-top: 10%">
      <div class="card shadow text-center mb-3 custom-card" style="width: 18rem; margin-left: 10px; margin: 0" v-if="moduloCSI">
        <div class="card-body" @click="menu('CSI')">
          <h5 class="card-title">
            <img src="../../../assets/exercicio.png" class="rounded" alt="" id="imgFoto" style="flex: 1; object-fit: cover; max-width: 50px; max-height: 50px" />
          </h5>
          <p class="card-text">CSI</p>
        </div>
      </div>
      <div class="card shadow text-center mb-3 custom-card" style="width: 18rem; margin-left: 10px" v-if="moduloPSICOLOGIA">
        <div class="card-body" @click="menu('PSICOLOGIA')">
          <h5 class="card-title">
            <span> <i class="fa fa-brain" style="font-size: 48px"></i></span>
          </h5>
          <p class="card-text">Psicologia</p>
        </div>
      </div>
      <div class="card shadow text-center mb-3 custom-card" style="width: 18rem; margin-left: 10px" v-if="moduloCONFIGURACAO">
        <div class="card-body" @click="menu('CONFIGURAÇÕES')">
          <h5 class="card-title">
            <span><i class="fa fa-cog" style="font-size: 48px"></i> </span>
          </h5>
          <p class="card-text">Configurações</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { modalLoginSSO } from '../../../utils/sso';
import { getRoutesPermission } from '../../../router/routes';
import { moduloSistema } from '../../../config/system';
import { setModuloMenuSelecionado, removerModuloMenuSelecionado, getDataUser } from '../../../utils/index';
export default {
  name: 'PageInicio',
  props: {
    msg: String,
  },
  data() {
    document.getElementById('sider-bar').style.display = 'none';
    this.mostrarMenu = false;
    return {
      texto: '',
      moduloCSI: false,
      moduloPSICOLOGIA: false,
      moduloCONFIGURACAO: false,
      menus: getRoutesPermission(getDataUser()),
      mostrarMenu: false,
    };
  },
  async created() {
    removerModuloMenuSelecionado();
    this.validarPermissaoModulo();
  },

  methods: {
    async menu(nomeMenu) {
      //var menus = getRoutesPermission(getDataUser());
      this.nomeMenu = nomeMenu;
      this.mostrarMenu = true;
      //validarMenus(menus, nomeMenu);
      setModuloMenuSelecionado(nomeMenu);
      //this.$router.push('/home', { shallow: true });
      const url = new URL('/home', window.location.origin);
      window.location.href = url.toString();
      //setTimeout(() => (this.$router.push('/home')),500);
    },
    validarPermissaoModulo() {
      this.menus.forEach((menu) => {
        if (menu.modulo === moduloSistema.CSI) {
          this.moduloCONFIGURACAO = true;
        }
        if (menu.modulo === moduloSistema.PSICOLOGIA) {
          this.moduloPSICOLOGIA = true;
        }
        if (menu.modulo === moduloSistema.CONFIGURACAO) {
          this.moduloCONFIGURACAO = true;
        }
      });
    },
  },

  setup() {
    const teste = () => {
      modalLoginSSO();
    };

    return {
      teste,
    };
  },
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.custom-card {
  transition: border 0.3;
  /* Adiciona uma transição suave para a mudança de borda */
  cursor: pointer;
}

.custom-card:hover {
  border: 2px solid #007bff;
  /* Cor e espessura da borda no hover */
}
</style>
